/**
 * 获取列表界面的搜索项
 */
export function getSearchData(flag) {
    let data = []
    switch (flag) {
        case "paper":
            // 试卷
            data = [{
                    title: "名称",
                    type: "input",
                    value: "",
                    key: "name"
                },
                {
                    title: "科目",
                    type: "select",
                    value: "",
                    key: "subject",
                    options: []
                },
            ]
            break;

        default:
            break;
    }
    return data
}
/**
 * 获取界面搜索框旁边的按钮
 * @param {*} flag  标识哪个界面
 */
export function getTopButArray(flag) {
    let data = []
    switch (flag) {
        case "paper":
            // 试卷列表
            data = [
                { name: "新增试卷", active: "create", icon: "el-icon-plus" },
                // { name: "试卷导入", active: "import", icon: "el-icon-upload" },
            ]
            break;
        default:
            break;
    }
    return data
}
/**
 * 获取题库列表表头数据
 */
export function getQuestionTableMenu() {
    return [
        { name: "试卷名称", key: "name", isStar: false },
        { name: "创建者", key: "createUer", isStar: false },
        { name: "相关科目", key: "subject", isStar: false },

    ]
}

/**
 * 模拟题库列表数据
 */
export function initTableData() {
    return [
        { id: "111", name: "2023年3月份月考A卷", createUer: "管理员A", subject: "军事基础1,军事基础2...", }
    ]
}

/**
 * 获取表格操作按钮
 * @param {*} flag  表示当前为哪个界面的
 */
export function getTableBUttonList(flag) {
    switch (flag) {
        case "paper":
            // 试卷
            return [
                { text: "预览", active: "preview" },
                { text: "编辑", active: "edit_paper" },
                { text: "删除", active: "delete_paper" },
            ]
            break;

        default:
            break;
    }
}

/**
 * 试卷编辑数据 
 */
export function getPaperEditPageData() {
    return [
        { title: "试卷名称", type: "input", key: "name", value: "", isNotNull: true, ishe: true },
        { title: "总分", type: "input", key: "totalPoints", value: "", isNotNull: true, ishe: true, tip: "分钟" },
        { title: "相关科目", type: "selects-linkage", key: "subject", value: [{ subjectId: '', proportion: "0" }], isNotNull: true, ishe: true, option: [] },
        { title: "题型分布", type: "distribute", key: "questionDistribute", value: [], option: [], isNotNull: true, ishe: true },

    ]
}